import React from 'react';
import styled from 'styled-components';

const StyledSvg = styled.svg`
  position: absolute;
  width: 105%;
  height: auto;
  bottom: 51%;
  left: -9%;

  .cls-1 {
    fill: #231f20;
  }

  .cls-2 {
    opacity: 0.45;
  }

  .cls-3 {
    fill: #f1f2f2;
  }

  .cls-4 {
    fill: #d1d3d4;
  }
`;

const Eyewear = () => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width="351.005"
      height="149.072"
      viewBox="0 0 351.005 149.072"
    >
      <g id="Group_114" data-name="Group 114" transform="translate(-173.293 -262.833)">
        <g id="Group_104" data-name="Group 104">
          <path
            id="Path_133"
            data-name="Path 133"
            className="cls-1"
            d="M178.288,334.2a5,5,0,0,1-.492-9.975l30.373-2.735a5,5,0,1,1,.995,9.95l-30.373,2.735A5.018,5.018,0,0,1,178.288,334.2Z"
          />
        </g>
        <path
          id="Path_134"
          data-name="Path 134"
          className="cls-1"
          d="M327.667,329.333s3.67-3.7,11.639,10.587c7.111,12.747,8.361,33.8-7.242,20.08C324.178,353.066,327.667,329.333,327.667,329.333Z"
        />
        <path
          id="Path_135"
          data-name="Path 135"
          className="cls-1"
          d="M291.713,331.922s-11.537,23.25-3,24.852S293.53,336.987,291.713,331.922Z"
        />
        <g id="Group_107" data-name="Group 107">
          <g id="Group_105" data-name="Group 105" className="cls-2">
            <circle
              id="Ellipse_36"
              data-name="Ellipse 36"
              className="cls-3"
              cx="56.709"
              cy="56.709"
              r="56.709"
              transform="translate(182.294 280.739)"
            />
          </g>
          <g id="Group_106" data-name="Group 106">
            <path
              id="Path_136"
              data-name="Path 136"
              className="cls-1"
              d="M239,398.158a60.709,60.709,0,1,1,60.71-60.709A60.778,60.778,0,0,1,239,398.158Zm0-113.419a52.709,52.709,0,1,0,52.71,52.71A52.769,52.769,0,0,0,239,284.739Z"
            />
          </g>
        </g>
        <g id="Group_110" data-name="Group 110">
          <g id="Group_108" data-name="Group 108" className="cls-2">
            <circle
              id="Ellipse_37"
              data-name="Ellipse 37"
              className="cls-3"
              cx="70.536"
              cy="70.536"
              r="70.536"
              transform="translate(327.064 266.833)"
            />
          </g>
          <g id="Group_109" data-name="Group 109">
            <path
              id="Path_137"
              data-name="Path 137"
              className="cls-1"
              d="M397.6,411.9a74.536,74.536,0,1,1,74.537-74.536A74.62,74.62,0,0,1,397.6,411.9Zm0-141.072a66.536,66.536,0,1,0,66.537,66.536A66.611,66.611,0,0,0,397.6,270.833Z"
            />
          </g>
        </g>
        <g id="Group_111" data-name="Group 111">
          <path
            id="Path_138"
            data-name="Path 138"
            className="cls-1"
            d="M327.062,336.191a4.981,4.981,0,0,1-3.284-1.231c-5.514-4.808-10.86-7.057-15.894-6.67a16.569,16.569,0,0,0-10.355,5.026,5,5,0,1,1-7.633-6.459,26.746,26.746,0,0,1,17.231-8.538c7.8-.593,15.615,2.471,23.223,9.1a5,5,0,0,1-3.288,8.768Z"
          />
        </g>
        <g id="Group_112" data-name="Group 112">
          <path
            id="Path_139"
            data-name="Path 139"
            className="cls-1"
            d="M466.131,333.793a5,5,0,0,1-.514-9.974l53.16-7.177a5,5,0,1,1,1.039,9.946l-53.16,7.178A5.186,5.186,0,0,1,466.131,333.793Z"
          />
        </g>
        <g id="Group_113" data-name="Group 113">
          <path
            id="Path_140"
            data-name="Path 140"
            className="cls-4"
            d="M471.62,329.66a1.5,1.5,0,0,1-.16-2.991l3.824-.516a1.5,1.5,0,1,1,.324,2.982l-3.824.516A1.513,1.513,0,0,1,471.62,329.66Z"
          />
        </g>
      </g>
    </StyledSvg>
  );
};

export default React.memo(
  Eyewear,
  (prevProps, nextProps) => prevProps.fill === nextProps.fill
);
